import Alpine from 'alpinejs'

Alpine.data('ratepayInstallments', (rates: Array<{ 
    numberOfPayments: number,
    amountFormatted: string,
    descriptionHtml: string,
}>) => ({

    isOpen: false,
    selectedRate: rates[0],
    rates: rates,

    init() {
        if(this.rates.length > 0) {
            this.select(this.rates[0])
        }
    },
    
    hasRates() {
        return this.rates.length > 0
    },
    
    select(rate) {
        this.selectedRate = rate
        this.close()
    },
    
    open() {
        this.isOpen = true
    },
    
    close() {
        this.isOpen = false
    },
    
    toggle() {
        if(this.isOpen) {
            this.close()
        } else {
            this.open()
        }
    }
    
}));